// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:07
import { TrafficIncidentsResults_abstract } from './../abstract/SagaBase/TrafficIncidentsResults_abstract';
export class TrafficIncidentsResults extends TrafficIncidentsResults_abstract {}
